import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../components/Login";
import RouteGuard from "./RouteGuard";
import AdminDashboard from "../components/AdminDashboard";
import UserManagement from "../components/UserManagement";
import Settings from "../components/Settings";
import NotFound from "../utils/NotFound";
import { decodeData } from "../utils/Helper";
import BetLists from "../components/BetLists";
import Withdraws from "../components/Withdraws";
import PaymentProviders from "../components/PaymentProviders";
import Winners from "../components/Winners";
import Results from "../components/Results";
import Deposits from "../components/Deposits";
import TransactionHistory from "../components/TransactionHistory";
import UserReport from "../components/reports/UserReport";
import ChangeSelfPassword from "../components/ChangeSelfPassword";
import PaymentReport from "../components/reports/PaymentReport";
import DepositWithdrawReport from "../components/reports/DepositWithdrawReport";
import SessionReport from "../components/reports/SessionReport";
import SessionReportDetails from "../components/reports/SessionReportDetails";

export default function Routers() {
  const token = decodeData(localStorage.getItem("r_c_a"));

  return (
    <Router basename="/">
      <Routes>
        <Route path="/login" element={<Login />} />

        {token?.user_role === "admin" && (
          <>
            <Route
              path="/"
              element={
                <RouteGuard>
                  <AdminDashboard />
                </RouteGuard>
              }
            />
            <Route
              path="/bet-lists"
              element={
                <RouteGuard>
                  <BetLists />
                </RouteGuard>
              }
            />
            <Route
              path="/settings"
              element={
                <RouteGuard>
                  <Settings />
                </RouteGuard>
              }
            />

            <Route
              path="/withdraws"
              element={
                <RouteGuard>
                  <Withdraws />
                </RouteGuard>
              }
            />

            <Route
              path="/deposits"
              element={
                <RouteGuard>
                  <Deposits />
                </RouteGuard>
              }
            />

            <Route
              path="/transaction-history"
              element={
                <RouteGuard>
                  <TransactionHistory />
                </RouteGuard>
              }
            />

            <Route
              path="/user-reports"
              element={
                <RouteGuard>
                  <UserReport />
                </RouteGuard>
              }
            />

            <Route
              path="/payment-reports"
              element={
                <RouteGuard>
                  <PaymentReport />
                </RouteGuard>
              }
            />

            <Route
              path="/deposit-withdraw-reports"
              element={
                <RouteGuard>
                  <DepositWithdrawReport />
                </RouteGuard>
              }
            />

            <Route
              path="/session-reports"
              element={
                <RouteGuard>
                  <SessionReport />
                </RouteGuard>
              }
            />

            <Route
              path="/session-reports/:result_id"
              element={
                <RouteGuard>
                  <SessionReportDetails />
                </RouteGuard>
              }
            />

            <Route
              path="/change-password"
              element={
                <RouteGuard>
                  <ChangeSelfPassword />
                </RouteGuard>
              }
            />

            <Route
              path="/users"
              element={
                <RouteGuard>
                  <UserManagement />
                </RouteGuard>
              }
            />

            <Route
              path="/payment-providers"
              element={
                <RouteGuard>
                  <PaymentProviders />
                </RouteGuard>
              }
            />

            <Route
              path="/winners"
              element={
                <RouteGuard>
                  <Winners />
                </RouteGuard>
              }
            />

            <Route
              path="/results"
              element={
                <RouteGuard>
                  <Results />
                </RouteGuard>
              }
            />

            <Route
              path="/*"
              element={
                <RouteGuard>
                  <NotFound />
                </RouteGuard>
              }
            />
          </>
        )}
        <Route path="/*" element={<RouteGuard />} />
      </Routes>
    </Router>
  );
}
